import * as React from "react";

export class ViewAllLink extends React.PureComponent < {
    title : string,
    href : string,
    handler: Function
}, {} > {

    render() {
        return (
            <div className="rj-ev-list__view-all-link__wrap" data-uat="div-ev-list-view-all-link-wrap">
                <a className="rj-ev-list__view-all-link" href={this.props.href} onClick={(e) => this.props.handler(e, e.target)} data-uat="a-ev-list-view-all-link">{this.props.title}</a>
            </div>
        );
    }

}